import styled from 'styled-components';

export const SliderInput = styled.input`
	background: linear-gradient(to right, #ff932a 0%, rgb(255 147 42) 67.9245%, #a1a1a1 67.9245%, #a1a1a1 100%);
	width: 100%;
	height: 13px;
	border-radius: 16px;  
	outline: none;
	opacity: 0.95;
	-webkit-transition: .2s;
	transition: opacity .2s; 
	-webkit-appearance: none;

	&:disabled {
		cursor: not-allowed !important;
	}
	 
	&.facet-slider-range{
		height: 10px;
	}
	@media (max-width: 1315px){
		height:12px;
	}

	&::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 22px;
  height: 22px;
  border-radius: 50%; 
  background: var(--toggleThumbColor);
  cursor: pointer;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 2px 8px;
}

	&::-moz-range-thumb {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--toggleThumbColor);
  cursor: e-resize;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 2px 8px;
	// background: #434343;
}

&[type="range"] {
	margin: 0 !important;
}

&[type="range"]:disabled::-webkit-slider-thumb {
	cursor: not-allowed !important;
}

&[type="range"]:disabled::-moz-range-thumb {
	cursor: not-allowed !important;
}

@media (max-width: 768px) {
	width: 100%;
}
	@media (max-width: 480px) {
	width: 100%;
}

`;

export const SliderWrap = styled.div`
	// background: #f2f2f2;
	padding: 2px 2px 3px 0px;
	border-radius: 16px;
	margin-bottom: 0px;
	position:relative;
	width: 100%;
	top: 2.5px;
	max-width: 286px;
	
	&.edit-fecet-slider{
		padding-left:0;
		top:0;
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
	}
  &.shading-wrap{
		flex-direction:column;
		max-width: 100%;
    padding: 4px 0px 5px;
    border-bottom: none;
    border-radius: 4px;
    background: transparent;
    margin-bottom: 16px;
	}

	@media (max-width: 840px) {
	max-width: 100%;
}
`;

export const TotalPanel = styled.span` 
		color: var(--subHeadingColor);
    font-weight: 600;
		font-size:1.063rem;

		@media (max-width: 1325px) {
		font-size:1rem;
	}
`;

export const PitchWrap = styled.div` 
		color: var(--textTitleColor);
    font-family: 'Inter';
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
		gap: 5px;
		margin-bottom: 0px !important;

		label{
			font-size: 14px;
			line-height: 16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--textTitleColor);
		}
		span{
				color: var(--labelValueColor);
		}	

		.pitch-degree{
			font-size: 14px;
			line-height: 16px;
			font-weight: 600;
			position: relative;
			min-width: 28px;
			color: var(--textHeadingColor);
		}
		.pitch-fraction{
			font-size: 14px;
			line-height: 16px;
			font-weight: 600;
			position: relative;
			color: var(--labelValueColor);
		}
		&.facet-pitch-detail{
			label, span{
				font-size: 14px;
				line-height: 16px;
			}
		}
		&.non-pitch-label{
			span{
				color: var(--labelValueColor);
			}
		}	
`;

export const FacetPropsKeyValue = styled.div` 
		color: var(--subHeadingColor);
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
		margin-bottom: 0.5rem;
		gap: 5px;

		.value{
			font-size: 14px;
			font-weight: 600;
			position: relative;
			color: var(--labelValueColor);
			line-height: 16px;
		}
`;